export const table = {
  wrapper: {
    style: {
      borderRadius: "8px",
    },
  },

  header: {
    gap: "middle",
    justify: "space-between",
    wrap: "wrap"
  },

  fixedHeader: {
    style: {
      position: 'sticky',
      top: -16,
      zIndex: 1000,
      background: 'var(--ant-component-background, var(--ant-color-bg-container))',
      paddingBottom: '8px',
      marginBottom: '8px',
    }
  },

  addSemesterButton: {
    type: "primary",
  },

  saveButton: {
    type: "primary",
    style: {
      background: "#0eaf65",
    },
  },

  actionsSection: {
    gap: "middle",
    wrap: "wrap",
    align: "center"
  },

  calculateButton: {
    type: "primary",
  },
  evaluateButton: {
    type: "primary",

  },
  resetButton: {
    type: 'primary',
    style: {
      background: '#ff8399'
    }
  }
};
